import { useEffect, useState } from 'react'

// La règle d'affichage, sans une ligne de syntaxe.
// Trois listes, une phrase en français, et c'est tout ce que voit l'utilisateur.
// La chaîne technique est reconstruite au moment d'enregistrer.
export default function RuleBuilder({ vocabulaire, valeur, onChange }) {
  const [mode, setMode] = useState(valeur ? 'si' : 'toujours')
  const [champ, setChamp] = useState('')
  const [operateur, setOperateur] = useState('==')
  const [reponse, setReponse] = useState('')

  useEffect(() => {
    const lu = lire(valeur, vocabulaire)
    if (lu) { setChamp(lu.champ); setOperateur(lu.operateur); setReponse(lu.reponse); setMode('si') }
    else if (vocabulaire.length) { setChamp(vocabulaire[0].var) }
  }, [valeur, vocabulaire])

  const def = vocabulaire.find((v) => v.var === champ)
  const operateurs = def?.operators || []
  const sansValeur = ['is_empty', 'not_empty', 'oui', 'non'].includes(operateur)

  function emettre(c = champ, o = operateur, r = reponse) {
    if (mode === 'toujours' || !c) return onChange('')
    if (o === 'oui') return onChange(`${c} == "Oui"`)
    if (o === 'non') return onChange(`${c} == "Non"`)
    if (o === 'is_empty' || o === 'not_empty') return onChange(`${c} ${o}`)
    onChange(`${c} ${o} "${String(r).replace(/"/g, '')}"`)
  }

  return (
    <div className="regle">
      <label htmlFor="mode">Cette question est-elle posée à tout le monde ?</label>
      <select id="mode" value={mode} onChange={(e) => {
        setMode(e.target.value)
        if (e.target.value === 'toujours') onChange('')
        else emettre()
      }}>
        <option value="toujours">Oui, à tout le monde</option>
        <option value="si">Non, seulement dans certains cas</option>
      </select>

      {mode === 'si' && (
        <>
          {vocabulaire.length === 0 && (
            <p className="avert">Aucune question ne précède celle-ci : il n'y a rien sur quoi
              poser une règle pour l'instant.</p>
          )}
          <div className="trois">
            <select value={champ} aria-label="Question" onChange={(e) => {
              const v = e.target.value
              const nouveau = vocabulaire.find((x) => x.var === v)
              const op = nouveau?.operators?.[0]?.op || '=='
              setChamp(v); setOperateur(op); setReponse('')
              emettre(v, op, '')
            }}>
              {vocabulaire.map((v) => <option key={v.var} value={v.var}>{v.label}</option>)}
            </select>

            <select value={operateur} aria-label="Comparaison" onChange={(e) => {
              setOperateur(e.target.value); emettre(champ, e.target.value, reponse)
            }}>
              {operateurs.map((o) => <option key={o.op} value={o.op}>{o.label}</option>)}
            </select>

            {sansValeur ? <span className="rien">rien à saisir</span>
              : def?.options?.length ? (
                <select value={reponse} aria-label="Réponse" onChange={(e) => {
                  setReponse(e.target.value); emettre(champ, operateur, e.target.value)
                }}>
                  <option value="">Choisir…</option>
                  {def.options.map((o) => <option key={o}>{o}</option>)}
                </select>
              ) : (
                <input value={reponse} aria-label="Réponse attendue" placeholder="la réponse attendue"
                       onChange={(e) => { setReponse(e.target.value); emettre(champ, operateur, e.target.value) }} />
              )}
          </div>

          <p className="phrase">
            Se lit : « afficher si <strong>{def?.label || '…'}</strong>{' '}
            {operateurs.find((o) => o.op === operateur)?.label || ''}{' '}
            {!sansValeur && <strong>{reponse || '…'}</strong>} »
          </p>
        </>
      )}
    </div>
  )
}

// Relit une règle existante pour repositionner les trois listes.
function lire(expr, vocabulaire) {
  if (!expr || /\|\||&&/.test(expr)) return null
  const m = expr.trim().match(/^([a-zA-Z0-9_]+)\s*(==|!=|>=|<=|>|<|contains|is_empty|not_empty)\s*(.*)$/)
  if (!m) return null
  const [, champ, op, brut] = m
  const reponse = brut.trim().replace(/^["']|["']$/g, '')
  const def = vocabulaire.find((v) => v.var === champ)
  if (def?.type === 'checkbox' && op === '==') {
    return { champ, operateur: reponse === 'Non' ? 'non' : 'oui', reponse: '' }
  }
  return { champ, operateur: op, reponse }
}
